export default {
  data() {
    return {
      rules: {
        required: v => (v === 0 || !!v) || 'This field is required',
        min: v => v && v.length >= 4 || 'Atleast 4 characters',
        repeatPassword: v => v == this.item.password || 'Must be the same with password',
        existing: v => v != this.existingUsername || 'This number was already registered',
        mobile: value => {
            // const pattern = /^(09|\+639)\d{9}$/;
            const pattern = /^(09)\d{9}$/;
            return pattern.test(value) || 'Invalid phone number';
        },
        email: value => {
            if(value && value.length > 0) {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || 'Invalid email';
            }
            return true;
        },
        legalAge: value => {
            var today = new Date();
            var birthDate = new Date(value);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age >= 16 || 'Age must be atleast 16';
        }
      }
    }
  },
}